import React from 'react';
import { Button, Box, CircularProgress } from '@mui/material';

const SaveButton = (props) => {
    return (
        <Box sx={{ Width: 200, height: 40 }}>
            <Button variant="contained" color="primary" onClick={props.onClick} size="large" disabled={props.disabled}>
                {props.loading && <CircularProgress size={18} color="inherit" sx={{ mr: 1 }} />}
                {props.loading ? 'Saving...' : 'Save'}
            </Button>
        </Box>
    );
}

export default SaveButton;
